<template>
  <v-autocomplete
    v-bind="$props"
    v-on="$listeners"
    return-object
    chips
    autocomplete
    clearable
    placeholder="Filter uploads by name"
    v-model="selectedUploads"
    :loading="isLoading"
    :items="isCustomUpload ? [selectedUploads] : uploads"
    :item-text="getItemDisplayText"
    single-line
  >
    <template v-slot:append-outer>
      <v-file-input
        prepend-icon="mdi-plus-circle"
        v-model="selectedUploads"
        hide-input
        dense
      />
    </template>
    <template v-slot:selection>
      <span class="upload-selection-text">{{ selectedUploads.name }}</span>
    </template>
  </v-autocomplete>
</template>

<style>
.upload-selection-text {
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
</style>

<script>
import { filesApiV2 } from '@/api/v2';

export default {
  name: 'UploadsSelectV2',
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    selected: {
      // Can be a File type if user uploads a new file
      type: [Object, File]
    },
    uploadType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      uploads: [],
      selectedUploads: this.selected
    };
  },
  async created() {
    this.isLoading = true;
    this.getUploads(this.uploadType);
    this.isLoading = false;
  },
  watch: {
    selected() {
      this.selectedUploads = this.selected;
    },
    selectedUploads() {
      this.$emit('uploadSelect', this.selectedUploads);
    }
  },
  computed: {
    isCustomUpload() {
      return this.selectedUploads instanceof File;
    }
  },
  methods: {
    async getUploads(type) {
      if (!type) {
        return;
      }

      const { items } = await filesApiV2.getFiles({
        type
      });
      this.uploads = items;
    },
    getItemDisplayText({ id, name }) {
      return name + (id ? ` (${id})` : '');
    }
  }
};
</script>
